module.exports = __webpack_public_path__ + "img/flora_supplementbasic.24a78b45.jpg";